import React from 'react'
import Heading from './Heading'
import { Grid } from '@mui/material'
import FullName from './FullName'
import Number from './Number'
import Address from './Address'
import Phone from './Phone'

const StorageUnitBillingForm = () => {
  return (
    <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
      <Heading header={'فرم صورتحساب واحد ذخیره‌سازی'} subHeader={'لطفا فرم را برای تولید صورتحساب واحد انبار خود پر کنید.'} />
      <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
        <FullName header={'نام و نام خانوادگی'} />
        <Phone header={'شماره واحد'} />
        <Address header={'آدرس صورتحساب'} />
        <Number header={'مدت زمان نگهداری (ماه)'} />
        <Number header={'نرخ ماهانه (دلار)'} />
        <Number header={'کل مبلغ قابل پرداخت (دلار)'} />
      </Grid>
    </Grid>
  )
}

export default StorageUnitBillingForm
